import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "../lib/AdminAuthContext";

export default function AdminProtected({ children }) {
  const { admin, checking } = useAdminAuth();
  const loc = useLocation();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="admin-loading">
        Loading admin…
      </div>
    );
  }
  if (!admin) return <Navigate to="/admin/login" state={{ from: loc.pathname }} replace />;
  return children;
}
